import { render, staticRenderFns } from "./CancellationCard.vue?vue&type=template&id=65e23db9&"
import script from "./CancellationCard.vue?vue&type=script&lang=js&"
export * from "./CancellationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports